import Vue from 'vue';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import App from './App.vue';
import router from './router';
import * as config from './shared/config/config';
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';

import SideBar from './components/sidebar';

import axios from 'axios';
import AuthService from "@/auth/auth.service";
import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import AlertService from '@/shared/alert/alert.service';
import ProductService from '@/services/product/product.service';
import QueriesService from '@/services/queries/queries.service';
import ReportService from '@/services/reports/reports.service';
import LogsService from '@/services/logs/logs.service';
import AggregateService from '@/services/aggregated/aggregate.service';
import UserService from '@/services/user/user.service';
import DataUtilsService from '@/shared/data/data-utils.service';

import RevenueService from '@/services/revenue/revenue.service';

import UploadingService from '@/services/uploading/uploading.service';

import './assets/custom.scss';
import './assets/utility-classes.css';

Vue.config.productionTip = false;

config.initVueApp(Vue);

Vue.use(SideBar);

const store = config.initVueXStore(Vue);


config.initFortAwesome(Vue);
Vue.component('font-awesome-icon', FontAwesomeIcon);

const authService = new AuthService();

const userService = new UserService(store, (<any>Vue).cookie, router);

const logsService = new LogsService();
const alertService = new AlertService(store);
const productService = new ProductService();
const queriesService = new QueriesService();
const reportService = new ReportService();
const aggregateService = new AggregateService();
const dataUtilsService = new DataUtilsService();
const revenueService = new RevenueService();
const uploadingService = new UploadingService();

bootstrapVueConfig.initBootstrapVue(Vue);

router.beforeEach((to, from, next) => {

    if (!store.getters.authenticated) {
        authService.login();
    }

    if (!to.matched.length) {
        next('/not-found');
    }

    if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
        if (!userService.hasAnyAuthority(to.meta.authorities)) {
            next('/forbidden');
        } else {
            next();
        }
    } else {
        // no authorities, so just proceed
        next();
    }
});


/* tslint:disable */
new Vue({
    el: '#app',
    components: { App },
    template: '<App/>',
    router,
    store,
    provide: {
        authService: () => authService,
        logsService: () => logsService,
        alertService: () => alertService,
        productService: () => productService,
        queriesService: () => queriesService,
        reportsService: () => reportService,
        aggregateService: () => aggregateService,
        userService: () => userService,
        dataUtilsService: () => dataUtilsService,
        revenueService: () => revenueService,
        uploadingService: () => uploadingService
    }

});



localStorage.removeItem("current_account");
Vue.prototype.updateCurrentAccount = function (){
    return new Promise(function(resolve) {
        return axios.get("/api/azure/insight/account").then((response) => {
            localStorage.setItem("current_account", JSON.stringify(response.data));
            resolve(response.data);
        });
    });
};

Vue.prototype.updateLocalAccount = function (account) {
    localStorage.setItem("current_account", JSON.stringify(account));
};

Vue.prototype.getCurrentAccount = function () {
    if (localStorage.getItem("current_account")) {
        return new Promise(function(resolve) {
            resolve(JSON.parse(localStorage.getItem("current_account")));
        });
    } else {
        return Vue.prototype.updateCurrentAccount();
    }
};

if (authService.isAuthenticated()) {
    /** Application Insight for Microsoft Azure **/
    axios.get("/api/azure/insight/key").then((response) => {
        const appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: response.data
            }
        });

        Vue.prototype.getCurrentAccount().then(function (account) {
            appInsights.loadAppInsights();
            appInsights.setAuthenticatedUserContext(account.azureId);
            router.afterEach((to, from) => {
                appInsights.trackPageView();
            });
        });
    });
}
